interface ListenerItem<T> 
{
    listener: (t?:T) => void;
    thisRef?: Record<string, unknown>;
}

export class Signal<T>
{
    private listeners: ListenerItem<T>[] = [];

    bind(listener: (t?:T) => void, thisRef?: Record<string, unknown>): void
    {
      this.listeners.push({ listener, thisRef });
    }

    unbind(listener: (t:T) => void): void
    {
      for (let i = 0; i < this.listeners.length; ++i) {
        const elm = this.listeners[i];
        if (elm.listener === listener) {
          this.listeners.splice(i, 1);
          return;
        }
      }
    }

    // optional if T = void
    dispatch(value?:T): void
    {
      for (const elm of this.listeners) {
        elm.listener.call(elm.thisRef, value);
      }
    }
}